<template lang="pug">
.collapse(
  v-if="$store.getters.selectedMatch ? $store.getters.selectedMatch == source.matchId && source.ptype == 30 : source.ptype == 30"
  :id="'league-' + source.groupId"
  :aria-labelledby="source.groupId"
  :class="[0,1,2,3,4,5,6].includes($dayjs().day()) && ['today','mmoparlay'].includes(menu1) || ['0','1','2','3','4','5','6'].includes(selectedDays) && ['early'].includes(menu1) ? '' : 'show'"
)
  .card-body.p-0
    //- small.text-light {{ menu1 }}
    .match(:class="[(source.marketId == 3) ? 'live' : [41, 42, 43, 44, 47].includes(source.sportsId) ? 'live' : '', leagueKindClassOf(source.leagueId)]")
      .match-info(v-if="![40].includes(source.sportsId)")
        .d-flex.match-info-team
          .match-info-home-name(:class="source.details['team'] == 1 ? 'team-red' : 'team-black'")
            .foul-card(v-if="source.matchBody[24] > 0 && source.matchBody[4] == 3")
              img(:src="'/images/red-card/red-card_' + source.matchBody[24] + '.svg?v=12'")
            .name {{ source.homeTeam }}
          TimePanel(:source="source")
          .match-info-away-name(:class="source.details['team'] == 0 ? 'team-red' : 'team-black'")
            .name {{ source.awayTeam }}
            .foul-card(v-if="source.matchBody[25] > 0 && source.matchBody[4] == 3")
              img(:src="'/images/red-card/red-card_' + source.matchBody[25] + '.svg?v=12'")
      .match-mainmarket.mmo
        MatchHDPOUMMOXOdds(
          v-if="source.betTypeId == 'hdpou' && [1].includes(source.sportsId) && source.hasOwnProperty('details')"
          :index="index"
          :source="source"
        )
      .d-flex.justify-content-between.match-function
        .d-flex
          .mr-2.icon-function.bg-star(@click="xSetFav($event)" :class="xIsFav() == true ? 'active' : ''")
          .mr-2.icon-function(v-if="source && source.betTypeId != 'parlay'")
            template(v-if="source.channelId")
              img(:src="(source.marketId == 3) ? '/images/live-stream-live.svg?v=12' : '/images/live-stream.svg?v=12'" @click="handleMore(source, 0)")
            template(v-else)
              template(v-if="source.channelId >= 1")
                img(:src="(source.marketId == 3) ? '/images/live-stream-live.svg?v=12' : '/images/live-stream.svg?v=12'")
          .mr-2.icon-function
            template(v-if="source.stats")
              img(:src="(source.marketId == 3) ? '/images/statistics-live.svg?v=12' : '/images/statistics.svg?v=12'" @click="xLinkStats(source)")
        .mr-0.more(v-if="source.details.momo > 0")
          a.text-dark(href='javascript:void(0);' @click="handleMore(source)")
            | {{ $t("ui.more_markets") }}
            i.fas.fa-chevron-right.ml-2
</template>

<script>
import config from "@/config";
import { EventBus } from "@/library/_event-bus.js";
import mixinTypes from "@/library/mixinTypes";
import TimePanel from "@/components/mobile/main/timePanel";
import MatchHDPOUMMOXOdds from "@/components/mobile/main/xmatch/matchHDPOUMMOXOdds";

export default {
  components: {
    TimePanel,
    MatchHDPOUMMOXOdds
  },
  mixins: [mixinTypes],
  props: {
    index: {
      type: Number
    },
    source: {
      type: Object
    }
  },
  data() {
    return {
      fav: false
    };
  },
  mounted() {
    if (this.favorite) {
      var isAll = true;
      var items = this.source.matches;
      for (var n in items) {
        if (this.favorite.indexOf(items[n][2]) == -1) {
          isAll = false;
        }
      }
      this.fav = isAll;
    }

    if (this.menu0 == "favorite") {
      this.fav = true;
    }

    this.syncGroupCollapse();
  },
  methods: {
    // Same reason as match.vue: a row added by a later pull must not render closed inside an open league
    syncGroupCollapse() {
      var groupId = this.source ? this.source.groupId : null;
      if (!groupId || !this.$el || !this.$el.classList) {
        return;
      }
      var panels = document.querySelectorAll("[id='league-" + groupId + "']");
      for (var i = 0; i < panels.length; i++) {
        if (panels[i] !== this.$el && panels[i].classList.contains("show")) {
          this.$el.classList.add("show");
          return;
        }
      }
    },
    handleMore(source, e) {
      this.$store.dispatch("layout/setSelectedMatch", source.matchId);
      this.$store.dispatch("layout/setSelectedMatchMore", source);
      this.$store.dispatch("layout/setRadarId", source.radarId);
      this.$store.dispatch("layout/setChannelId", source.channelId);
      if (e >= 0) {
        this.$router.push({ name: "moreX", params: { mode: e } }).catch(err => {});
      } else {
        this.$router.push("/moreX").catch(err => {});
      }
    },
    showTimeMachine(source) {
      if (EventBus.betTimeMachineDatetime) {
        EventBus.betTimeMachineDatetime(source);
      }
    },
    xIsFav() {
      if (this.favorite) {
        if (this.favorite.indexOf(this.source.matchId) != -1) {
          return true;
        }
      }
      return false;
    },
    xSetFav(evt) {
      var favList = [];
      if (favList.indexOf(this.source.matchId) == -1) {
        favList.push(this.source.matchId);
      }
      if (this.xIsFav(this.source.matchId)) {
        this.$store.dispatch("layout/delFavorite", favList);
      } else {
        this.$store.dispatch("layout/setFavorite", favList);
      }
      if (this.menu0 == "favorite") {
        setTimeout(() => {
          EventBus.$emit("GET_MARKET");
        }, 500);
      }
    },
    xLinkStats(e) {
      if (e && e.stats) {
        var url = config.statscenterUrl() + e.stats + "&u=" + this.$store.getters.accountId + "&t=" + this.$store.getters.sessionToken + "&l=" + this.$store.getters.language;
        window.open(url, '_blank', "stats", "top=10,height=540,width=900,status=no,toolbar=no,menubar=no,location=no");
      }
    }
  }
};
</script>
